var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 7.33301V14.6663M7.33398 10.9997H14.6673M20.1673 10.9997C20.1673 16.0623 16.0633 20.1663 11.0007 20.1663C5.93804 20.1663 1.83398 16.0623 1.83398 10.9997C1.83398 5.93706 5.93804 1.83301 11.0007 1.83301C16.0633 1.83301 20.1673 5.93706 20.1673 10.9997Z",
    stroke: "#3A3939",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle);
export default __webpack_public_path__ + "static/media/IconPlusCircle.2a01515b852573000189d5b261c8b96e.svg";
export { ForwardRef as ReactComponent };